import style from './Botao.module.scss';

const Botao = ({ tipo, children, cliqueBotao }) => {
  
  return (
    <button className={style.botao} type={tipo} onClick={cliqueBotao}>{children}</button>          
    
    
  )
}

export default Botao;
  